import { Component, inject, Input } from '@angular/core';
import { NgClass } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { DateRangePipe } from '../../../../../shared/pipes/date-range.pipe';
import { Event as EventModel } from '../../../../../shared/model/event';
import { GeoLocationService } from '../../../services/geo-location.service';

@Component({
  selector: 'app-game-table-event-card',
  standalone: true,
  imports: [DateRangePipe, RouterLink, NgClass],
  templateUrl: './game-table-event-card.component.html',
  styleUrl: './game-table-event-card.component.css'
})
export class GameTableEventCardComponent {
  protected geoLocationService: GeoLocationService = inject(GeoLocationService);
  private router: Router = inject(Router);

  @Input() event?: EventModel;

  protected onCardClick(event: MouseEvent | Event): void {
    if (!this.event?.id || this.isInteractiveTarget(event)) {
      return;
    }
    void this.router.navigate(['/events/detail', this.event.id]);
  }

  protected onCardKeydown(event: KeyboardEvent): void {
    if (event.key !== 'Enter' && event.key !== ' ') {
      return;
    }
    if (this.isInteractiveTarget(event)) {
      return;
    }
    event.preventDefault();
    this.onCardClick(event);
  }

  private isInteractiveTarget(event: Event): boolean {
    const target = event.target as HTMLElement | null;
    return !!target?.closest('a, button, input, select, textarea, label, [role="button"]');
  }
}
